var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFaLeaf(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_111_5212)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.913 0.049C22.357 0.075 9.262 0.72 4.862 5.12C3.12804 6.8589 2.09984 9.17857 1.97592 11.6311C1.852 14.0837 2.64115 16.4952 4.191 18.4L0 22.591L1.415 24L5.605 19.816C7.50992 21.3662 9.92174 22.1555 12.3746 22.0314C14.8274 21.9073 17.1473 20.8786 18.886 19.144C23.374 14.657 23.936 1.644 23.957 1.088L24 0L22.913 0.049ZM17.472 17.73C16.1084 19.0898 14.2966 19.9069 12.3747 20.0287C10.4529 20.1505 8.55236 19.5687 7.028 18.392L16.665 8.755L15.251 7.341L5.614 16.978C4.43726 15.4536 3.8555 13.5531 3.97731 11.6313C4.09913 9.70942 4.91621 7.89758 6.276 6.534C9.455 3.355 18.683 2.372 21.891 2.122C21.657 5.315 20.716 14.486 17.472 17.73Z",
    fill: "#0E4945"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_111_5212"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaLeaf);
export default __webpack_public_path__ + "static/media/faLeaf.0b16029e6092619a39f16f8714fb7277.svg";
export { ForwardRef as ReactComponent };